import { inject, NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ErrorComponent } from "./error/error.component";
import { LoginComponent } from "./login/login.component";
import { RouteType } from "./models/enum";
import { NotFoundComponent } from "./not-found/not-found.component";
import { RoleService } from "./shared/services/role.service";

const routes: Routes = [
	{ path: "", redirectTo: () => inject(RoleService).getDefaultRoute(), pathMatch: "full" },
	{
		path: "",
		loadChildren: () => import("./cbta-web/cbta-web.module").then((app) => app.CbtaWebModule),
	},
	{ path: RouteType.LOGIN, component: LoginComponent },
	{ path: RouteType.ERROR, component: ErrorComponent },
	{ path: "**", component: NotFoundComponent },
];
@NgModule({
	imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: "emptyOnly" })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
